// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new.tsx';
import FormError from 'src/core/gd-form/common/form-error/form-error.tsx';
import FormManager from 'src/core/gd-form/common/form-manager';

import Input from 'core/gd-form/form-element/input/input.jsx';
import Textarea from 'core/gd-form/form-element/textarea/textarea';
import FormSelect from 'core/gd-form/form-element/select-new/select-new';
// @ts-ignore
import Colorpicker from 'core/gd-form/form-element/color-picker/color-picker.jsx';
import ButtonSubmit from 'core/gd-form/common/btn-submit/btn-submit';
// @ts-ignore
import TaskTypeIcon from 'i5-task';
import ProjectIcon from 'core/gd-ui/project-icon/project-icon.tsx';

import ProjectStatusManager from 'src/core/gd/manager/project-status-manager';

import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";
// @ts-ignore
import SessionLoader from "core/gd/data/session-loader";
import Loading from "core/gd-ui/loading/loading";
import ItemId from "../../gd-ui/id/item-id";

class CreateNew extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        params: PropTypes.object.isRequired,
        statusId: PropTypes.string,

        onClickBack: PropTypes.func.isRequired,
        onClick: PropTypes.func
    }

    constructor(props) {
        super(props);

        const { NOT_STARTED, IN_PROGRESS, ON_HOLD, COMPLETED, CANCELLED } = gd.const.systemStatus;

        let status

        if (props.statusId) {
            status = _.find(gd.const.suggestedStatuses, s=>s.id === props.statusId);
            if (!status) status = gd.session.statuses.get(props.statusId);
        }

        const initFormData = status ? status : {
            name: '',
            description: '',
            systemStatus: props.params.systemStatus ? props.params.systemStatus : null, //NOT_STARTED,
            color: null
        }

        if (!initFormData.description) initFormData.description = ''

        const formStructure = {
            fields: {
                systemStatus: {
                    type        : 'select',
                    isRequired  : true,
                    label       : 'System status',
                    onUserChange: this.onSystemStatusChange
                },
                name: {
                    type        : 'input',
                    isRequired  : true,
                    validator   : (val, form)=>{
                        const { project, organization } = props.params;
                        //const selectedSystemStatus = form.getValue("systemStatus");

                        const companyId = project ? project.companyId : organization.id ;
                        const existingStatuses = gd.session.statuses.filter(s=>s.companyId === companyId);
                        const existingStatus = _.find(existingStatuses, s=>(!status || status.id !== s.id)
                                && gd.utils.compare(s.name,val)
                                && !s.isDeleted
                            /*&& s.systemStatus === selectedSystemStatus*/);

                        if (existingStatus) return "Status '"+val+"' already exists";

                        return true;
                    }
                },
                description: {
                    type        : 'input',
                    isRequired  : false
                },
                color: {
                    type        : 'select',
                    isRequired  : true
                },
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData)

        this.originalSystemStatus = initFormData.systemStatus;

        const hasMissingTemplates = this._checkForMissingTemplates();

        this.state = {
            showColorSelector: ![COMPLETED, CANCELLED].includes(initFormData.systemStatus),
            isLoading: hasMissingTemplates
        }
    }

    _checkForMissingTemplates = () => {
        // check for missing templates
        const projects = gd.session.projects.filterByCompany(gd.companyId)
        const missing = gd.session.findMissing({
            projects: _.uniq(_.map(projects.models, p=>p.localTemplateId)),
        })

        const hasMissingTemplates = !_.isEmpty(missing)

        if (hasMissingTemplates) {
            let sessionLoader = new SessionLoader()
            sessionLoader.done(()=>{
                this.setState({
                    isLoading: false
                })
            })
            sessionLoader.process(missing)
        }

        return hasMissingTemplates
    }

    onSubmit = (result) => {
        result.name = result.name.trim();
        this.props.onSubmit(result);
    }

    onSystemStatusChange = () => {
        const { NOT_STARTED, IN_PROGRESS, ON_HOLD, COMPLETED, CANCELLED } = gd.const.systemStatus;

        const showColorSelector = ![COMPLETED, CANCELLED].includes(this.form.getValue("systemStatus"));
        this.form.setFieldIsRequired('color', showColorSelector);
        if (!showColorSelector) this.form.setValue('color', gd.const.statusColor.GRAY);
        this.form.validateField('name');

        this.setState({
            showColorSelector: showColorSelector
        });
    }

    closeModal = (e) => {
        e.stopPropagation();
        gd.modal.hide();
    }

    onClickTaskType(tt) {
        gd.goTo('settings/task-types/'+tt.id);
    }

    onClickProject(p) {
        gd.goTo('p/'+p.id+'/settings/basic');
    }

    renderUsedIn() {
        const { statusId } = this.props;
        const status = gd.session.statuses.get(statusId);
        const { companyId } = status;
        let res = [];
        let moreCustomProjectWorkflow = 0;

        const taskTypes = gd.session.taskTypes.filterByCompany(companyId);

        const usedInTaskTypes = [];
        _.map(taskTypes.models, tt=>{
            if (tt.isDeleted) return;
            const found = _.find(tt.statuses.models, s=>s.statusId === statusId);
            if (found) {
                usedInTaskTypes.push(tt.id);
                res.push(
                    <div key={tt.id} className="used-in-item" onClick={this.onClickTaskType.bind(this,tt)}>
                        <TaskTypeIcon className="used-in-icon" icon={tt.icon} hint={false} />
                        <div className="used-in-name">{tt.name}</div>
                    </div>
                );
            }
        });

        const projects = gd.session.projects.filterByCompany(companyId);
        const usedInTemplates = [];
        const usedInCustomProjects = [];
        projects.map(p=>{
            if (p.isDeleted) return;

            const isFound = ![
                    gd.const.project.type.TAG,
                    gd.const.project.type.WORKFOLDER
                ].includes(p.systemType) &&
                _.find(ProjectStatusManager.getProjectStatuses(p.id, {idOnly:true}), sId=>sId === statusId);
            if (isFound) {
                if (p.isTemplate) {
                    usedInTemplates.push(p.id);
                    res.push(
                        <div key={p.id} className="used-in-item" onClick={this.onClickProject.bind(this,p)}>
                            <ProjectIcon className="used-in-icon" projectId={p.id}/>
                            <div className="used-in-name">{p.name}</div>
                        </div>
                    );
                } else if (p.statuses && p.statuses.length > 0) {
                    usedInCustomProjects.push(p.id);
                    moreCustomProjectWorkflow++;
                }
            }
        });

        if (moreCustomProjectWorkflow > 0) {
            const label = moreCustomProjectWorkflow > 1 ? moreCustomProjectWorkflow + " projects" : "1 project";
            res.push(
                <div key="custom-workflow" className="used-in-item">
                    <div className="used-in-name">Custom project workflow ({label})</div>
                </div>
            );
        } else if (res.length === 0) res = <div className="used-in-notification">not in use</div>;

        //console.log("CreateNew renderUsedIn", usedInTaskTypes, usedInTemplates, usedInCustomProjects);

        return res;
    }

    renderHeader() {
        const { isEditing, newOnly } = this.props.params;

        if (isEditing) {
            return <ModalV4Header height={60} title="Edit Status" onClose={this.closeModal} />;
        }

        if (!newOnly) {
            return <ModalV4Header height={60} title="New Status" onClose={this.closeModal}  onGoBack={this.props.onClickBack}/>
        } else {
            return <ModalV4Header height={60} title="New Status" onClose={this.closeModal} />;
        }
    }

    renderLoading() {
        return (
            <div className="v4-container placement-middle add-new">
                <Loading />
            </div>
        )
    }

    render() {
        if (this.state.isLoading) return this.renderLoading()

        const { onClickBack, onClick } = this.props;
        const { isEditing, newOnly, systemStatus } = this.props.params;
        const { NOT_STARTED, IN_PROGRESS, IN_REVIEW, ON_HOLD, COMPLETED, CANCELLED, OPEN_STATUSES, CLOSED_STATUSES } = gd.const.systemStatus;

        // when editing, only same-group values are selectable - the backend rejects
        // open<->closed moves, so don't even offer them here
        const allowedSystemStatuses = isEditing
            ? (OPEN_STATUSES.includes(this.originalSystemStatus) ? OPEN_STATUSES : CLOSED_STATUSES)
            : [NOT_STARTED, IN_PROGRESS, IN_REVIEW, ON_HOLD, COMPLETED, CANCELLED];

        const systemGroupOptions = allowedSystemStatuses.map(name=>({
            label: gd.const.systemStatusList[name], value: name
        }));

        const { LIGHT_BLUE, GREEN, RED, PINK, ORANGE, VIOLET, GRAY } = gd.const.statusColor;
        const colorOptions = [LIGHT_BLUE, GREEN, RED, PINK, ORANGE, VIOLET, GRAY].map(c=>({
            value: c,
            label: 'status-color-'+c
        }));

        const submitLabel = isEditing ? "Save" : "Create status";

        return (
            <div className="v4-container placement-middle add-new" onClick={onClick}>
                {this.renderHeader()}

                <Form className="create-new-status-form main" form={this.form} submitButton={false}>
                    {isEditing &&
                    <div className="warning-message">
                        Warning: all changes made here will apply to all projects and tasks that have this status.
                    </div>}

                    <div className="tbl">
                        <div className="row">
                            <div className="label">Name</div>
                            <div className="element">
                                <Input size="big"
                                       form={this.form}
                                       name="name"/>
                                <FormError form={this.form} name="name" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="label">Description</div>
                            <div className="element">
                                <Textarea size="2-rows"
                                          rows={2}
                                          form={this.form}
                                          name="description" />

                                <FormError form={this.form} name="description" />
                            </div>
                        </div>

                        {(isEditing || !systemStatus) &&
                        <div className="row cf">
                            <div className="label">System group</div>
                            <div className="element">

                                <FormSelect className="system-group-selector default-skin"
                                        form={this.form}
                                        name="systemStatus"
                                        options={systemGroupOptions} />

                                <FormError form={this.form} name="systemStatus" />
                            </div>
                        </div>}

                        {this.state.showColorSelector &&
                        <div className="row cf">
                            <div className="label">Color</div>
                            <div className="element">
                                <Colorpicker form={this.form}
                                             size="big"
                                             name="color"
                                             items={colorOptions}/>

                                <FormError form={this.form} name="color" />
                            </div>

                        </div>}

                        <div className="row cf">
                            <div className="label">System ID</div>
                            <div className="element used-in">
                                <ItemId copyId={true} itemId={this.props.statusId} itemName="Status" renderType="property-30" />
                            </div>
                        </div>

                        {isEditing &&
                        <div className="row cf">
                            <div className="label">Used in</div>
                            <div className="element used-in">
                                {this.renderUsedIn()}
                            </div>
                        </div>}
                    </div>
                </Form>

                <div className="modal-submit">
                    <ButtonSubmit form={this.form} label={submitLabel} className="submit" />
                </div>
            </div>
        );
    }
}

module.exports = CreateNew;
